export const EXPAND_PARTICLE = 'EXPAND_PARTICLE'
export const CLOSE_PARTICLE = 'CLOSE_PARTICLE'
export const APPLY_CONFIGURATION = 'APPLY_CONFIGURATION'
export const SET_PARENT_DIMENSIONS = 'SET_PARENT_DIMENSIONS'
export const SET_PARTICLE_POSITION = 'SET_PARTICLE_POSITION'
export const APP_SCROLLPOSITION_Y = 'APP_SCROLLPOSITION_Y'
export const SET_LANGUAGE = 'SET_LANGUAGE'

export const expandParticle = (id, position) => {
  return {
    type: EXPAND_PARTICLE,
    id,
    position
  }
}

export const closeParticle = (id, position) => {
  return {
    type: CLOSE_PARTICLE,
    id,
    position
  }
}

export const applyConfiguration = (configuration) => {
  return {
    type: APPLY_CONFIGURATION,
    configuration
  }
}

export const parentDimensions = (top, height) => {
  return {
    type: SET_PARENT_DIMENSIONS,
    top: top,
    height: height
  }
}

export const particlePosition = (id, position) => {
  return {
    type: SET_PARTICLE_POSITION,
    id,
    position
  }
}

export const setScrollPosY = (offset) => {
  return {
    type: APP_SCROLLPOSITION_Y,
    offset
  }
}

export const setLanguage = (lang) => {
  return {
    type: SET_LANGUAGE,
    lang
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/